import { Table } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import { FormikErrors } from 'formik'
import * as React from 'react'

import { FormValues } from '../form'
import { CreateNewDiscussionForm } from './CreateNewDiscussionForm'

import styles from './TalkList.module.less'

export type TalkListBasicProps = {
    columns: ColumnProps<{}>[]
    onConversationClick: (record: {}) => void
    permissions: { canCreateNewConversation: boolean }
    submitCreateNewDiscussion: (
        values: FormValues
    ) => Promise<FormikErrors<FormValues>>
}

export type TalkListProps = TalkListBasicProps & {
    conversations: any
}

export const TalkList: React.FC<TalkListProps> = (props) => {
    const onRow = (record: {}, index: number): any => {
        return {
            onClick: (event: Event) => {
                props.onConversationClick(record)
            }
        }
    }

    return (
        <div className={styles.talkList}>
            <CreateNewDiscussionForm submit={props.submitCreateNewDiscussion} />
            <Table
                columns={props.columns}
                dataSource={props.conversations}
                // @ts-ignore
                onRow={onRow}
                rowKey="id"
            />
        </div>
    )
}
